import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import Brands from './Brands';
import styles from './index.module.scss';
import { useEffect, useRef, useState } from 'react';

const Energy: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('Energy');
    const videoRef = useRef<HTMLVideoElement>(null);

    const items: any[] = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            poster: (() => {
                const posterMap: Record<string, string> = {
                    en: 'https://websiteoss.ecoflow.com/upload/image/1754400482948/16_en_pc.jpg',
                    de: 'https://websiteoss.ecoflow.com/upload/image/1754400482948/16_en_pc.jpg',
                };
                return posterMap[locale] || posterMap.en;
            })(),
            pc: (() => {
                const videoMap: Record<string, string> = {
                    en: 'https://websiteoss.ecoflow.com/upload/video/1755163728166/16_en.mp4',
                    de: 'https://websiteoss.ecoflow.com/upload/video/1755163709889/16_de.mp4',
                };
                return videoMap[locale] || videoMap.en;
            })(),
            isVideo: true,
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            pc: 'https://websiteoss.ecoflow.com/upload/image/1754041926224/16_2.jpg',
            pad: 'https://websiteoss.ecoflow.com/upload/image/1754041926022/16_2_M.jpg',
        },
    ];

    const [load, setLoad] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const sceneEnergy = AniContainer.create({
                triggerElement: '.stream-ultra-x-M',
                triggerHook: 1,
                onEnter: () => setLoad(true),
            });
            return () => {
                sceneEnergy.destroy();
            };
        }
    }, []);

    useEffect(() => {
        const video = videoRef.current;
        if (!video) return;

        const handleVideoPlay = () => {
            video.play();
        };

        video.addEventListener('canplaythrough', handleVideoPlay);
        return () => video.removeEventListener('canplaythrough', handleVideoPlay);
    }, [load]);

    return (
        <div
            className={`${styles.Energy} GtmModuleData-section`}
            id="stream-ultra-x-Energy"
            data-section-id={'stream-ultra-x-Energy'}
            data-section-title={t('title')}
        >
            <EcoSectionCommon className="top-box" title={t('title')} />
            <div className="eco-content content-box">
                {items.map((item, index) => (
                    <div className="content-box-item" key={index}>
                        <div className="content-box-item-left">
                            <div className="content-box-item-title">{item.title}</div>
                            <div className="content-box-item-desc">{item.desc}</div>
                        </div>
                        <div className="content-box-item-right">
                            {item?.isVideo ? (
                                <div className="video" style={{ width: '100%', height: '100%' }}>
                                    {load && (
                                        <video
                                            src={item.pc}
                                            poster={item?.poster}
                                            ref={videoRef}
                                            loop
                                            muted
                                            autoPlay
                                            preload="metadata"
                                            playsInline
                                            width="100%"
                                            height="100%"
                                            aria-label={t('title')}
                                        />
                                    )}
                                </div>
                            ) : (
                                <EcoImg pc={item.pc} pad={item.pad} alt={item.title} />
                            )}
                        </div>
                    </div>
                ))}
            </div>

            <EcoSectionCommon className="bottom-box" title={t('item3_title')} desc={t('item3_desc')} />
            <Brands />
        </div>
    );
};

export default Energy;
